export default "__VITE_ASSET__cb937a7e__"